import { Component } from '@poa/core';
import { observable, Observer } from '@poa/state';
import Raven from 'raven-js';
import React from 'react';
import AutosizeInput from 'react-input-autosize';
import MaskedInput from 'react-maskedinput';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { validateFee } from '../../../utils/fee';
import { GRANTED_HOSTS } from '../../../store/auth/auth.constants';

export class PrefetchSelect extends React.Component {
  static defaultProps = { clearable: true, isSearchable: true };
  state = { data: [], current: this.props.current || null, loading: true };

  componentDidMount() {
    if (this.props.options) {
      this.mapResponseToState(this.props.options);
      return;
    }

    if (this.props.types) {
      this.setState({ loading: false });

      const requests = this.props.types.map(type => 
        this.env.http.get(type, { params: { AccountId: this.props.accountId } })
          .then(response => response.data)
          .catch(error => {
            console.error(`Error fetching data for type ${type}:`, error);
            return [];
          })
      );

      Promise.all(requests)
        .then(data => {
        const items = new Map();

        [].concat(...data).forEach(item => {
          if (!items.has(item.id)) {
            items.set(item.id, item);
          }
        });

        this.mapResponseToState([...items.values()]);
      });
      return;
    }

    this.env.http.get(this.props.type, { params: { AccountId: this.props.accountId } }).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  refreshData() {
    if (this.props.options) {
      this.mapResponseToState(this.props.options);
      return;
    }

    this.env.http.get(this.props.type, { params: { AccountId: this.props.accountId } }).then(response => {
      this.mapResponseToState(response.data);
    });
  }

  updateLeadOptions = (inputValue) => {
    if (this.props.types) {
      Promise.all(
        this.props.types.map(type => this.env.http.get(
          type, { params: { Name: inputValue, AccountId: this.props.accountId } }
        ).then(response => response.data))
      ).then(data => {
        const items = new Map();
        [].concat(...data).forEach(item => {
          if (!items.has(item.id)) {
            items.set(item.id, item);
          }
        });
        this.mapResponseToState([...items.values()]);
      });
    } else if (this.props.type) {
      this.env.http.get(
        this.props.type, { params: { Name: inputValue, AccountId: this.props.accountId } }
      ).then(response => {
        this.mapResponseToState(response.data);
      });
    }
  };

  mapResponseToState(response) {
    if (this.props.transformResponse) {
      response = this.props.transformResponse(response);
    }

    let current = response.find(item => item.id === this.props.current);

    if (this.props.selectFirstAndFire) {
      current = response[0];
      this.handleChange({ label: this.getLabelFromItem(current), value: current.id });
    }

    let loadedData = response.map(item => ({
      label: this.getLabelFromItem(item),
      value: item.id
    }));

    let selectedOption = current ? { label: this.getLabelFromItem(current), value: current.id } : null;
    let foundElement = this.state.data.find(element => element.value === this.props.current);

    if (foundElement) {
      selectedOption = foundElement;

      let foundElementIsPresent = loadedData.find(element => element.value === this.props.current);
      if (!foundElementIsPresent) {
        loadedData.push({
          label: foundElement.label,
          value: foundElement.id
        })
      }
    }

    this.setState({
      data: loadedData,
      selectedOption: selectedOption,
      loading: false
    });
  }

  getLabelFromItem(item) {
    if (item.title) {
      return item.title;
    }

    if (this.props.titleExtractor) {
      return this.props.titleExtractor(item);
    }

    return `${item.first_name} ${item.last_name}`;
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    this.props.onChange(selectedOption ? selectedOption.value : null);
    this.props.handleChangeExtended && this.props.handleChangeExtended(selectedOption);
  };

  handleInputChange = (inputValue) => {
    if ((this.props.types && (
      this.props.types.includes('scouts') ||
      this.props.types.includes('account-managers') ||
      this.props.types.includes('teamleads') ||
      this.props.types.includes('operators') ||
      this.props.types.includes('managers')
    )) || (['teamleads', 'operators', 'managers', 'scouts','account-managers'].includes(this.props.type))) {

      if (inputValue.length >= 2) {
        this.updateLeadOptions(inputValue);
      } else {
        if (typeof this.props.accountId === 'undefined') {
          this.setState({ data: [] });
        } else {
          this.refreshData();
        }
      }
    }
  };

  render() {
    return (
      <Select
        style={this.props.optionalStyle}
        searchable={this.props.isSearchable}
        name='form-field-name'
        disabled={!this.props.editMode}
        value={this.state.selectedOption || ''}
        isLoading={this.state.loading}
        onChange={this.handleChange}
        options={this.state.data}
        clearable={this.props.clearable}
        placeholder={this.t('selectPlaceholder')}
        noResultsText={this.t('noResults')}
        onInputChange={this.handleInputChange}
      />
    );
  }
}

PrefetchSelect = Component({ namespaces: ['popup'] })(PrefetchSelect);

export const ProfileTabForm = Component()(
  class extends React.Component {
    componentDidCatch(error, errorInfo) {
      this.localState.errored = true;

      if (process.env.NODE_ENV === 'production') {
        Raven.captureException(error, { extra: errorInfo });
      }
      console.error(error);
    }

    localState = observable({ selectedSite: null, errored: false, isPasswordVisible: false, passwordMessage: 'Show Password'});


    handlePasswordVisibility = async () => {

      try {
        await this.env.api.users.fetchAccountPassword(this.props.state.model.account[this.props.selectedSite.get().value].id);
        this.localState.isPasswordVisible = !this.localState.isPasswordVisible;
      } catch (error) {
        console.error(error);
        this.localState.passwordMessage = 'Denied Access';
      }
    }

    render() {
      const props = this.props;
      const { state } = props;
      const isInputsActive = !props.state.isEditMode;

      if (this.localState.errored) {
        return 'Error occured while rendering. Accident reported. Please, reload the page.';
      }

      switch (props.variant) {
        case 'agency': {
          let data;

          if (state.selectedSite && state.model[state.selectedSite]) {
            data = state.model[state.selectedSite];
          } else {
            data = state.model;
          }

          if (state.isAdding) {
            data = state.model;
          }

          if (state.isEmpty) {
            return (
              <div className='tab active' data-tab='questionnaire'>
                <div className='tab__inner'>
                  <div
                    className='account-info'
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <div className='account-info__left'>
                      <button
                        type='button'
                        className='filter-columns__save'
                        onClick={() => {
                          state.isEmpty = false;
                          state.isAdding = true;
                          state.isEditMode = true;
                        }}
                      >
                        Создать
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div className='tab active' data-tab='questionnaire'>
              <div className='tab__inner' style={{ display: 'flex' }}>
                <div
                  className='account-info'
                  style={{
                    borderRight: '1px solid #ccc',
                    paddingRight: '25px'
                  }}
                >
                  <div className='account-info__left'>
                    <ul className='account-info__list'>
                      {state.isAdding && (
                        <li className='account-info__item'>
                          <div className='account-info__name'>Сайт</div>
                          <PrefetchSelect
                            editMode={true}
                            type='sites'
                            selectFirstAndFire
                            clearable={false}
                            current={null}
                            onChange={value => (state.selectedSite = value)}
                          />
                        </li>
                      )}
                      <li className='account-info__item'>
                        <div className='account-info__name'>{data.fee_verbose}</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              min={0}
                              max={100}
                              value={data.fee}
                              onChange={({ target }) => (data.fee = validateFee(target.value))}
                            />
                          )}
                        </Observer>
                      </li>
                    </ul>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>
                          {data.manager_default_percent_verbose}
                        </div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              value={data.manager_default_percent}
                              onChange={({ target }) =>
                                (data.manager_default_percent = target.value)
                              }
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>
                          {data.scout_default_percent_verbose}
                        </div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              value={data.scout_default_percent}
                              onChange={({ target }) => (data.scout_default_percent = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>
                          {data.teamlead_default_percent_verbose}
                        </div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              value={data.teamlead_default_percent}
                              onChange={({ target }) =>
                                (data.teamlead_default_percent = target.value)
                              }
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>
                          {data.operator_default_percent_verbose}
                        </div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              value={data.operator_default_percent}
                              onChange={({ target }) =>
                                (data.operator_default_percent = target.value)
                              }
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>
                          {data.account_default_percent_verbose}
                        </div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              value={data.account_default_percent}
                              onChange={({ target }) =>
                                (data.account_default_percent = target.value)
                              }
                            />
                          )}
                        </Observer>
                      </li>
                    </ul>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>{data.include_calls_verbose}</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.include_calls}
                              onChange={({ target }) => (data.include_calls = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>{data.include_gifts_verbose}</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.include_gifts}
                              onChange={({ target }) => (data.include_gifts = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>{data.include_video_verbose}</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.include_video}
                              onChange={({ target }) => (data.include_video = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                    </ul>
                  </div>
                </div>

                {!state.isAdding && (
                  <div
                    className='account-info'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      paddingLeft: '25px'
                    }}
                  >
                    <div className='account-info__left'>
                      <button
                        type='button'
                        className='filter-columns__save'
                        onClick={() => {
                          state.isEmpty = false;
                          state.isAdding = true;
                          state.isEditMode = true;

                          state.setAdding();
                        }}
                      >
                        Создать
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        }
        case 'staff': {
          const data = state.model;

          return (
            <div className='tab active' data-tab='questionnaire'>
              <div className='tab__inner' style={{ display: 'flex' }}>
                <div
                  className='account-info'
                  style={{
                    borderRight: '1px solid #ccc',
                    paddingRight: '25px'
                  }}
                >
                  <div className='account-info__left'>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Фамилия *</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.last_name}
                              onChange={({ target }) => (data.last_name = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Имя *</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.first_name}
                              onChange={({ target }) => (data.first_name = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Почта *</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.email}
                              onChange={({ target }) => (data.email = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Телефон</div>
                        <Observer>
                          {() => (
                            <MaskedInput
                              minWidth={150}
                              mask='+111(11)111-11-11'
                              placeholder='+XXX(XX)XXX-XX-XX'
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.phone}
                              onChange={({ target }) => (data.phone = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Пол</div>
                        <PrefetchSelect
                          editMode={props.state.isEditMode}
                          current={data.gender}
                          options={[{ id: 'М', title: 'М' }, { id: 'Ж', title: 'Ж' }]}
                          onChange={value => (data.gender = value)}
                        />
                      </li>
                    </ul>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>сайт</div>
                        <PrefetchSelect
                          editMode={props.state.isEditMode}
                          type='sites'
                          current={data.site_id}
                          onChange={value => (data.site_id = value)}
                        />
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>група *</div>
                        <PrefetchSelect
                          editMode={props.state.isEditMode}
                          type='groups'
                          current={data.group_id}
                          onChange={value => (data.group_id = value)}
                        />
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>уровень</div>
                        <PrefetchSelect
                          editMode={props.state.isEditMode}
                          type='levels'
                          current={data.level_id}
                          onChange={value => (data.level_id = value)}
                        />
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>руководитель</div>
                        <PrefetchSelect
                          editMode={props.state.isEditMode}
                          types={['managers', 'teamleads']}
                          options={
                            (data.lead_id !== null & data.lead !== null) ? [
                            {
                              id: data.lead_id, 
                              last_name: data.lead.split(' ')[0], 
                              first_name: data.lead.split(' ')[1] 
                            }] 
                            : null
                          }
                          current={data.lead_id}
                          onChange={value => (data.lead_id = value)}
                        />
                      </li>
                    </ul>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Логин *</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              name='plaintext3'
                              autocomplete='new-password'
                              value={data.login}
                              onChange={({ target }) => (data.login = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Новый пароль *</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='password'
                              name='plaintext1'
                              autocomplete='new-password'
                              value={data.password}
                              onChange={({ target }) => (data.password = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <Observer>
                        {() => (
                          <li className='account-info__item'>
                            <div className='account-info__name'>
                              Повторить новый пароль *{' '}
                              <span style={{ color: 'red' }}>
                                {state.isPasswordMatched ? '(не совпадает!)' : null}
                              </span>
                            </div>
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='password'
                              name='plaintext2'
                              autocomplete='new-password'
                              value={data.confirm}
                              onChange={({ target }) => (data.confirm = target.value)}
                            />
                          </li>
                        )}
                      </Observer>
                    </ul>
                  </div>
                </div>
                <div className='account-info' style={{ paddingLeft: '25px' }}>
                  <div className='account-info__left'>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>%</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              min={0}
                              max={100}
                              value={data.percent_payment}
                              onChange={({ target }) =>
                                (data.percent_payment = validateFee(target.value))
                              }
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>% выплата</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.fixed_payment}
                              onChange={({ target }) => (data.fixed_payment = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Ставка</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='number'
                              min={0}
                              max={100}
                              value={data.pay_percent}
                              onChange={({ target }) => (data.pay_percent = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Ставка выплата</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.pay_fixed}
                              onChange={({ target }) => (data.pay_fixed = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Активен</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='checkbox'
                              checked={data.is_active}
                              onChange={({ target }) => (data.is_active = target.checked)}
                            />
                          )}
                        </Observer>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        case 'credentials': {
          const data = state.model;

          return (
            <div className='tab active' data-tab='questionnaire'>
              <div className='tab__inner'>
                <div className='account-info'>
                  <div className='account-info__left'>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Title</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.title}
                              onChange={({ target }) => (data.title = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Login</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='text'
                              value={data.login}
                              onChange={({ target }) => (data.login = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                    </ul>
                    <ul className='account-info__list'>
                      <li className='account-info__item'>
                        <div className='account-info__name'>Новый пароль</div>
                        <Observer>
                          {() => (
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='password'
                              value={data.password}
                              onChange={({ target }) => (data.password = target.value)}
                            />
                          )}
                        </Observer>
                      </li>
                      <Observer>
                        {() => (
                          <li className='account-info__item'>
                            <div className='account-info__name'>
                              Повторить новый пароль{' '}
                              <span style={{ color: 'red' }}>
                                {state.isPasswordMatched ? '(не совпадает!)' : null}
                              </span>
                            </div>
                            <AutosizeInput
                              minWidth={150}
                              disabled={isInputsActive}
                              inputClassName='account-info__val'
                              type='password'
                              value={data.confirm}
                              onChange={({ target }) => (data.confirm = target.value)}
                            />
                          </li>
                        )}
                      </Observer>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        default:
          break;
      }

      const data = state.model.account[props.selectedSite.get().value];

      return (
        <div className='tab active' data-tab='questionnaire'>
          <div className='tab__inner'>
            <div className='account-info'>
              <div className='account-info__left'>
                <ul className='account-info__list'>
                  <li className='account-info__item'>
                    <div className='account-info__name'>ник</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={true}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.nickname}
                          onChange={({ target }) => (data.nickname = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>пароль</div>

                    {this.localState.isPasswordVisible && (<Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.password}
                          onChange={({ target }) => (data.password = target.value)}
                        />
                      )}
                    </Observer>)}

                    {!this.localState.isPasswordVisible && (
                      <button className='account-info__val' style={{ color: this.localState.passwordMessage === 'Denied Access' ? 'red' : 'black' }}
                        onClick={this.handlePasswordVisibility}
                      >
                      {this.localState.passwordMessage}
                      </button>
                      )}

                    

                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>id</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={true}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.id}
                          onChange={({ target }) => (data.id = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>панель</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={true}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.panel}
                          onChange={({ target }) => (data.panel = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>довериe</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={true}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.trust}
                          onChange={({ target }) => (data.trust = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                  <div className='account-info__name'>Статус</div>
                    <Select
                      searchable={false}
                      name='status'
                      value={state.model.status}
                      onChange={target => {
                        state.model.status = target.value;
                      }}
                      options={[
                        { value: 'active', label: 'active' },
                        { value: 'inactive', label: 'inactive' },
                        { value: 'rejected', label: 'rejected' },
                        { value: 'suspended', label: 'suspended' },
                        { value: 'blocked', label: 'blocked' },
                        { value: 'deleted', label: 'deleted' },
                        { value: 'transferred', label: 'transferred' },
                        { value: 'transfered', label: 'transfered' },
                        { value: 'on verification', label: 'on verification' }
                      ]}
                      clearable={false}
                    />
                  </li>
                </ul>
                <ul className='account-info__list'>
                  <li className='account-info__item'>
                    <div className='account-info__name'>менеджер</div>
                    <PrefetchSelect
                      editMode={props.state.isEditMode}
                      type='managers'
                      current={data.manager_id}
                      clearable={true}
                      accountId={data.id}
                      handleChangeExtended={val => {
                        if (val === null) {
                          return (data.manager_id = null);
                        }
                      }}
                      onChange={value => {
                        return (data.manager_id = value);
                      }}
                    />
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>тимлид</div>
                    <PrefetchSelect
                      editMode={props.state.isEditMode}
                      type='teamleads'
                      current={data.teamlead_id}
                      accountId={data.id}
                      onChange={value => (data.teamlead_id = value)}
                      handleChangeExtended={val => {
                        if (val === null) {
                          return (data.teamlead_id = null);
                        }
                      }}
                    />
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>оператор</div>
                    <PrefetchSelect
                      editMode={props.state.isEditMode}
                      type='operators'
                      current={data.operator_id}
                      accountId={data.id}
                      onChange={value => (data.operator_id = value)}
                      handleChangeExtended={val => {
                        if (val === null) {
                          return (data.operator_id = null);
                        }
                      }}
                    />
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>скаут</div>
                    <PrefetchSelect
                      editMode={props.state.isEditMode}
                      type='scouts'
                      current={data.scout_id}
                      accountId={data.id}
                      onChange={value => (data.scout_id = value)}
                    />
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>аккаунт менеджер</div>
                    <PrefetchSelect
                      editMode={props.state.isEditMode}
                      type='account-managers'
                      accountId={data.id}
                      current={data.account_manager_id}
                      onChange={value => (data.account_manager_id = value)}
                    />
                  </li>
                </ul>
                <ul className='account-info__list'>
                  <li className='account-info__item'>
                    <div className='account-info__name'>телефон</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.telephone}
                          onChange={({ target }) => (data.telephone = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>e-mail</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.email}
                          onChange={({ target }) => (data.email = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>пароль почты</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.emailPass}
                          onChange={({ target }) => (data.emailPass = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>регистрация</div>
                    <Observer>
                      {() => (
                        <MaskedInput
                          style={{ minWidth: 100 }}
                          mask='11.11.1111'
                          placeholder='DD.MM.YYYY'
                          className='account-info__val'
                          disabled={this.store.auth.currentHost === GRANTED_HOSTS.nc}
                          type='text'
                          value={data.registrationDate}
                          onChange={({ target }) => (data.registrationDate = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>перевод</div>
                    <Observer>
                      {() => (
                        <MaskedInput
                          style={{ minWidth: 100 }}
                          mask='11.11.1111'
                          placeholder='DD.MM.YYYY'
                          disabled={isInputsActive}
                          className='account-info__val'
                          type='text'
                          value={data.transferDate}
                          onChange={({ target }) => (data.transferDate = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>регистратор</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.registrator}
                          onChange={({ target }) => (data.registrator = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>уровень анкеты</div>

                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={props.state.model.salary.accountLevel}
                          onChange={({ target }) =>
                            (props.state.model.salary.accountLevel = target.value)
                          }
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>гарантированная выплата</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='text'
                          value={data.salary}
                          onChange={({ target }) => (data.salary = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                  <li className='account-info__item'>
                    <div className='account-info__name'>План</div>
                    <Observer>
                      {() => (
                        <AutosizeInput
                          minWidth={100}
                          disabled={isInputsActive}
                          inputClassName='account-info__val'
                          type='number'
                          value={data.plan}
                          onChange={({ target }) => (data.plan = target.value)}
                        />
                      )}
                    </Observer>
                  </li>
                </ul>
              </div>
              <div className='account-info__right'>
                <div className='account-info__avatar'>
                  <img src={data.profilePhoto} alt='kinski' />
                  <div className='account-info__links'>
                    <a
                      className='account-info__link js-subpopup'
                      href='#/'
                      onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        props.requestGallery('photo');
                      }}
                    >
                      <svg
                        id='icon-photo'
                        className='icon icon-photo'
                        viewBox='0 0 14 12'
                        width='100%'
                        height='100%'
                      >
                        <path
                          d='M13.45 2.39a1.8 1.8 0 0 0-1.32-.54H10.5l-.37-.98a1.29 1.29 0 0 0-.51-.61C9.38.09 9.12 0 8.87 0H5.13c-.25 0-.51.09-.75.26-.25.17-.42.37-.51.61l-.37.98H1.87c-.52 0-.96.18-1.32.54-.37.36-.55.79-.55 1.3v6.46c0 .51.18.95.55 1.31.36.36.8.54 1.32.54h10.26c.52 0 .96-.18 1.32-.54.37-.36.55-.8.55-1.31V3.69c0-.51-.18-.94-.55-1.3zM9.31 9.21c-.64.63-1.41.94-2.31.94-.9 0-1.67-.31-2.31-.94a3.12 3.12 0 0 1-.96-2.29c0-.89.32-1.65.96-2.28A3.18 3.18 0 0 1 7 3.69c.9 0 1.67.32 2.31.95.64.63.96 1.39.96 2.28 0 .89-.32 1.65-.96 2.29z' />
                        <path
                          d='M7 5c-.55 0-1.02.2-1.41.59C5.2 5.98 5 6.45 5 7c0 .55.2 1.02.59 1.41.39.39.86.59 1.41.59.55 0 1.02-.2 1.41-.59C8.8 8.02 9 7.55 9 7c0-.55-.2-1.02-.59-1.41A1.93 1.93 0 0 0 7 5z' />
                      </svg>
                    </a>
                    <a
                      href='#/'
                      className='account-info__link js-subpopup'
                      onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        props.requestGallery('video');
                      }}
                    >
                      <svg
                        id='icon-camera'
                        className='icon icon-camera'
                        viewBox='0 0 15 15'
                        width='100%'
                        height='100%'
                      >
                        <path
                          d='M11 13.47c0 .29-.33.53-.73.53H.73c-.4 0-.73-.24-.73-.53V6.53C0 6.24.33 6 .73 6h9.54c.4 0 .73.24.73.53zM1 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm5-.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm9 12s-.07.5-.53.5C14 15 11 12.2 11 11.83V8.17C11 7.8 13.93 5 14.47 5c.53 0 .53.5.53.5z' />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
